import { render, staticRenderFns } from "./ZipInfo.vue?vue&type=template&id=12d710cf&scoped=true"
import script from "./ZipInfo.vue?vue&type=script&lang=js"
export * from "./ZipInfo.vue?vue&type=script&lang=js"
import style0 from "./ZipInfo.vue?vue&type=style&index=0&id=12d710cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d710cf",
  null
  
)

export default component.exports